import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import SlickSlider from '@/components/ui/slick-slider/SlickSlider';
import SlickSliderPartner from '@/components/ui/slick-slider/SlickSliderPartner';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import PodcastsBlock from './podcasts-block/PodcastsBlock';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { IAdvertisingBlock } from '@/interfaces/advertisingBlock';
import { IPodcastPage } from '@/interfaces/podcastsPage.interface';
import FreebooksBlock from './freebooks-block/FreebooksBlock';
import { IPopularBooks } from '@/interfaces/popularBooks.interface';

interface IHomePage {
  popularBooks: IPopularBooks;
  newBooks: IBookPage;
  advertisingBlock: IAdvertisingBlock;
  podcastsBlock: IPodcastPage;
  freeBooks: IBookPage;
}

const Home: FC<IHomePage> = ({ popularBooks, newBooks, advertisingBlock, podcastsBlock, freeBooks }) => {
  //seo block
  const SEO_TITLE = 'Куча книг - электронная библиотека. Скачать книгу, читать книги онлайн, электронные книги бесплатно.';
  const SEO_DESCRIPTION = 'Электронная библиотека - Куча книг. У нас можно читать книги, скачать книгу online бесплатно. Бесплатно - Электронная библиотека и электронные книги.';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/" isDefaultPopularSlider={false}>
      {freeBooks && freeBooks.data.length > 0 && <FreebooksBlock books={freeBooks} />}

      {podcastsBlock && podcastsBlock.data?.length > 0 && (
        <>
          <SectionTitle name={'Популярные подкасты'} />
          <PodcastsBlock podcastsBlock={podcastsBlock} />
        </>
      )}

      <SectionTitle name={'Новинки'} />
      <SlickSlider newBooks={newBooks.data} />

      <SectionTitleMenu extraClassName={'sectionTitleMenu_mainPage'}>
        <SectionTitle name={'Популярные книги'} extraClassName={'sectionHeading_plain'} />
      </SectionTitleMenu>
      <div data-cards="list" className="cardsWrapper">
        {popularBooks.length ? (
          popularBooks.map((book) => (
            <BookCardItem
              alias={book.alias}
              rating={book.rating}
              key={book.id}
              author={book.author}
              book={{ title: book.title, type: 'book', year: '', lang: '', description: book.description, genres: book.genres, external_id: book.external_id }}
              readOnline={true}
              // createdAt={book.created_at}
            />
          ))
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      {advertisingBlock && advertisingBlock.length > 0 && (
        <>
          <SectionTitle name={'Лучшие книги нашего партнера'} />
          <SlickSliderPartner books={advertisingBlock} />
        </>
      )}
    </Layout>
  );
};

export default Home;
